import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { PresentationAccessPage } from '../features/presentations/presentation-access-page';

const SearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  search: z.string().trim().max(200).optional().catch(undefined),
});

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/access',
)({ component: AccessRoute, validateSearch: zodValidator(SearchSchema) });

function AccessRoute() {
  const { companySlug, presentationId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PresentationAccessPage
      companySlug={companySlug}
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      onSearchChange={(next) =>
        void navigate({ search: (previous) => ({ ...previous, page: 1, search: next }) })
      }
      presentationId={presentationId}
      {...search}
    />
  );
}
